import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeService } from '../shared-service/root-scope.service';
import { CreateManagerService } from '../../pre-login/services/create-manager.service';
import { AuthenticationService } from '../services/authentication.service';
import { IFacilityUserSummary } from '../../core/services/facility.model';
import { FacilityService } from '../services/facility.service';
import { HaloLoaderService } from '../halo-loader/halo-loader.service';
import { CommonUtil } from '../Utils/common-util';
import { HaloToastService, EToastType } from '../halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from '../services/amplitude-analytics.service';
// import {} from "google.maps"; // for compiler.

@Component({
  selector: 'app-facility-info-confirmation',
  templateUrl: './facility-info-confirmation.component.html',
  styleUrls: ['./facility-info-confirmation.component.scss'],
})
export class FacilityInfoConfirmationComponent implements OnInit {
  @Input() action?: string;
  @Input() facilityInformation: IFacilityUserSummary;
  @Input() userInformation: IFacilityUserSummary;
  @Output() backBtnClickOnStep3: EventEmitter<string> = new EventEmitter();
  @Output() cancelBtnClickOnStep3: EventEmitter<string> = new EventEmitter();

  requiredData: IFacilityUserSummary;
  map: google.maps.Map;
  geocoder: google.maps.Geocoder;
  markers: { setMap: (arg0: null) => void }[];
  displayAddress: string;
  rootScopeData: RootScopeDeclare;
  isFacilityForm: boolean = false;
  operatingHours: string = '';

  constructor(
    private createManagerService: CreateManagerService,
    private cookieService: CookieService,
    private router: Router,
    private rootScopeService: RootScopeService,
    private authenticationService: AuthenticationService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _facilityService: FacilityService,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private _commonUtil: CommonUtil
  ) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.isFacilityForm = !!this.action;
    this.requiredData = {
      facility: this.facilityInformation.facility,
      user: this.isFacilityForm ? null : this.userInformation.user,
    };
    this.displayAddress = `${this.requiredData.facility.address}, ${this.requiredData.facility.city}${this.requiredData.facility.state?', '+this.requiredData.facility.state:''}, ${this.requiredData.facility.countryName}`;
    this.initMap();
    this.initFacilityForm();
  }

  initMap(): void {
    if (typeof this.map === 'undefined') {
      this.geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(-34.397, 150.644);
      const myOptions = {
        zoom: 16,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };
      const _mapEle = <HTMLElement>document.getElementById('map');
      this.map = new google.maps.Map(_mapEle, myOptions);
    } else {
      this.map.setZoom(16);
    }
    this.codeAddress();
  }

  codeAddress(): void {
    let addressToMap = this.displayAddress;
    this.geocoder.geocode({ address: addressToMap }, (results: google.maps.GeocoderResult[], status: string) => {
      if (status === google.maps.GeocoderStatus.OK) {
        this.map.setCenter(results[0].geometry.location);
        // alert(this.markers.length)
        if (this.markers?.length > 0) {
          let i = 0;
          while (i < this.markers.length) {
            this.markers[i].setMap(null);
            i++;
          }
          this.markers = [];
        }
        const marker = new google.maps.Marker({
          map: this.map,
          position: results[0].geometry.location,
        });
        this.markers?.push(marker);
      } else {
        // if (addressToMap.indexOf(',') >= 0 && !this.googleCantFindAddress) {
        //   const zoomLevel = (this.map.getZoom() || 3) - 2;
        //   this.map.setZoom(zoomLevel);
        //   addressToMap = addressToMap.substr(addressToMap.indexOf(',') + 1);
        //   this.codeAddress();
        // }
      }
    });
  }

  gotoStep2(): void {
    this.backBtnClickOnStep3.emit();
  }

  createAccount(): void {
    this.loader.startProcess();
    if (this.isFacilityForm) {
      if (this.action == 'add') {
        this._amplitudeAnalytics.logEvent({elementName: 'Add Facility', action: 'Submit'});
        this._facilityService.add(this.requiredData.facility).then(
          (res) => {
            this.rootScopeData.isPageHasUnsavedChanges = false;
            // this.toast.creatToast('Facility add success', EToastType.SUCCESS);
            this.toast.creatToast(this._commonUtil.replaceValueAsHTMLOnTranslatedText('FACILITY.CREATE.SUCCESS', [this.requiredData.facility.facilityName]), EToastType.SUCCESS);
            this.loader.endProcess();
            this.navigateToManageFacility();
          },
          (err) => {
            // this.toast.creatToast('Facility add fail', EToastType.ERROR);
            this.loader.endProcess();
          }
        );
      } else if (this.action == 'edit') {
        this._amplitudeAnalytics.logEvent({elementName: 'Edit Facility', action: 'Submit'});
        this._facilityService.update(this.requiredData.facility).then(
          (res) => {
            this.rootScopeData.isPageHasUnsavedChanges = false;
            this.toast.creatToast(this._commonUtil.replaceValueAsHTMLOnTranslatedText('FACILITY.UPDATE.SUCCESS', [this.requiredData.facility.facilityName]), EToastType.SUCCESS);
            this.loader.endProcess();
            this.navigateToManageFacility();
          },
          (err) => {
            // this.toast.creatToast('Facility edit fail', EToastType.ERROR);
            this.loader.endProcess();
          }
        );
      }
    } else {
      /*this.requiredData.facility.facilityHoursStart = '00';
    this.requiredData.facility.facilityMinsStart = '00';
    this.requiredData.facility.facilityHoursEnd = '24';
    this.requiredData.facility.facilityMinsEnd = '00';
    this.requiredData.user.nickname = 'aaaaaaabbbbbbbbb1';*/
      this._amplitudeAnalytics.logEvent({elementName: 'Sign Up', action: 'Submit'});
      this.createManagerService.createManagerAccount(this.requiredData).subscribe(
        (data) => {
          this.loader.endProcess();
          this.rootScopeData.isPageHasUnsavedChanges = false;
          this.cookieService.set('vtTokenKey', data.tokenKey, 0, '', '', true, 'None');
          this.cookieService.set('vtUserType', 'M', 0, '', '', true, 'None');
          localStorage.setItem('vtTokenKey', data.tokenKey);
          localStorage.setItem('vtUserType', 'M');
          Object.keys(data).forEach((key) => {
            if (this.rootScopeData.currentUser.hasOwnProperty(key))
              (this.rootScopeData.currentUser as any)[key] = (data as any)[key];
            return this.rootScopeData.currentUser;
          });
          if (this.requiredData.facility.isConnected === 'false') {
            this.cookieService.set('vtManagerType', 'N', 0, '', '', true, 'None');
          }
          this.authenticationService.reCheckVtTokenKey();

          if (this.requiredData.facility.isConnected === 'false' && !localStorage.getItem('userRequestedURL')) {
            this.router.navigate(['/facility/manage']);
          } else {
            this.authenticationService.authenticateUser();
            this.router.navigate(['/dashboard']);
          }

          this.rootScopeData.isAuthenticated = true;
          localStorage.setItem('isLoggedIn', 'true');

          //   this.cookieService.set('vtTokenKey', ssoCookie);
          //   this.cookieService.delete('ssoCookie');
          //   this.userValidations = data;
        },
        (error) => {
          this.loader.endProcess();
          console.error('API failed.');
        }
      );
    }

    this.authenticationService.updateAutoLogOutFlag(false); 
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  cancelSignup(): void {
    this.cancelBtnClickOnStep3.emit();
  }

  // facility add / edit

  initFacilityForm() {
    if (!this.isFacilityForm) {
      return;
    }
    this.getOperatingHours();
  }

  navigateToManageFacility() {
    this.router.navigate(['/facility/manage']);
  }

  getOperatingHours() {
    //
    let _openH = '',
      _closeH = '';
    
    if(this.requiredData.facility.facilityHoursStart == '00' && 
    this.requiredData.facility.facilityHoursEnd == '24'){
      this.operatingHours = '24 Hours';
    }else{
      // open hr
      let _ohInt: number = parseInt(this.requiredData.facility.facilityHoursStart, 10);
      let _chInt: number = parseInt(this.requiredData.facility.facilityHoursEnd, 10);

      if (_ohInt > 12) {
        _openH = `${_ohInt - 12}:${this.requiredData.facility.facilityMinsStart} PM`;
      }
      if (_ohInt > 12) {
        _openH = `${_ohInt - 12}:${this.requiredData.facility.facilityMinsStart} PM`;
      } else {
        _openH = `${this.requiredData.facility.facilityHoursStart}:${this.requiredData.facility.facilityMinsStart} AM`;
      }
      // close hr
      if (_chInt > 12) {
        _closeH = `${_chInt - 12}:${this.requiredData.facility.facilityMinsEnd} PM`;
      }
      if (_chInt > 12) {
        _closeH = `${_chInt - 12}:${this.requiredData.facility.facilityMinsEnd} PM`;
      } else {
        _closeH = `${this.requiredData.facility.facilityHoursEnd}:${this.requiredData.facility.facilityMinsEnd} AM`;
      }

      this.operatingHours = `${_openH} - ${_closeH}`;
    }
  }
}
